import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { HandbuchContent, S } from '../components/HandbuchContent';

export const HandbuchPage: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const p = user?.permissions;
  const isPrivileged = !!(p?.isAdmin || p?.isEinkauf || p?.isGeschaeftsfuehrer);

  const scrollTo = useCallback((id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  // Auto-Print wenn ?drucken=1 in der URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('drucken') !== '1') return;
    const timer = setTimeout(() => window.print(), 800);
    return () => clearTimeout(timer);
  }, [location.search]);

  return (
    <>
      {/* Print-Stylesheet */}
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; }
          img { max-width: 100% !important; page-break-inside: avoid; }
          h2, h3, h4 { page-break-after: avoid; }
          table { page-break-inside: avoid; }
        }
      `}</style>

      {/* Kopfleiste (wird beim Drucken ausgeblendet) */}
      <div className="no-print" style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'linear-gradient(135deg, #0078d4, #004578)',
        color: 'white',
        padding: '12px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontFamily: '"Segoe UI", sans-serif',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}>
        <span style={{ fontSize: 18, fontWeight: 300 }}>Bestellwesen – Bedienungshandbuch</span>
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={() => window.print()}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: '1px solid rgba(255,255,255,0.4)',
              color: 'white',
              borderRadius: 2,
              padding: '6px 16px',
              fontSize: 13,
              cursor: 'pointer',
              fontFamily: '"Segoe UI", sans-serif',
            }}
          >
            🖨 Als PDF drucken
          </button>
          <button
            onClick={() => window.close()}
            style={{
              background: 'transparent',
              border: '1px solid rgba(255,255,255,0.4)',
              color: 'white',
              borderRadius: 2,
              padding: '6px 16px',
              fontSize: 13,
              cursor: 'pointer',
              fontFamily: '"Segoe UI", sans-serif',
            }}
          >
            ✕ Schließen
          </button>
        </div>
      </div>

      {/* Inhalt */}
      <div style={{ ...S.scrollArea, maxWidth: 900, margin: '0 auto', padding: '0 40px 60px' }}>
        <HandbuchContent scrollTo={scrollTo} isPrivileged={isPrivileged} />
      </div>
    </>
  );
};
